"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const styled_components_1 = __importDefault(require("styled-components"));

const Column_1 = __importDefault(require("../column/Column"));
/**
 * This component fills any available space and places its children in the
 * center.
 *
 * NB: This component is inspired by, but not identical to the Flutter
 * equivalent.
 * @see https://api.flutter.dev/flutter/widgets/Center-class.html
 */


const Center = styled_components_1.default(Column_1.default).attrs(({
  crossAxisAlignment,
  mainAxisAlignment
}) => ({
  crossAxisAlignment: crossAxisAlignment !== null && crossAxisAlignment !== void 0 ? crossAxisAlignment : 'center',
  mainAxisAlignment: mainAxisAlignment !== null && mainAxisAlignment !== void 0 ? mainAxisAlignment : 'center'
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  width: 100%;\n  height: 100%;\n"])));
exports.default = Center;